import { Cityhall, Link } from "../../assets";
import { useTranslation } from "react-i18next";
import articleLookup from "../../assets/article-lookup.json";

const Footer = ({ data, partyQueryHandler, t }) => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  const handleLinkClick = (party) => {
    window.parent.location.href = articleLookup[language][party.partyId];
  };

  return (
    <div className="p-6 bg-wort-background">
      <div className="flex flex-row items-center mb-4">
        <div>
          <div className="w-14 h-14 bg-white flex justify-center items-center rounded-full">
            <Cityhall />
          </div>
        </div>
        <div className="ml-2">
          <span
            className="font-semibold text-xl"
            style={{ fontSize: 22, lineHeight: "26.4px" }}
          >
            {t("footerTitle")}
          </span>
        </div>
      </div>
      <div className="">
        <div className="mt-6 grid grid-cols-2 gap-1 md:grid-cols-4">
          {data.map((link, index) => {
            return (
              <div className="flex flex-row mt-4 space-x-2" key={index}>
                <Link />
                <span
                  className="ml-3 font-semibold leading-6 hover:underline cursor-pointer text-primary text-lg"
                  onClick={() => handleLinkClick(link)}
                >
                  {link.partyName}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Footer;
